import {InferActionsTypes} from './store'

const initialState = {
    loading: 0,
}

type InitialState = typeof initialState
type Actions = InferActionsTypes<typeof actions>


const loadingReducer = (state = initialState, action: Actions): InitialState => {
    switch (action.type) {
        case 'SET_LOADING': {
            return {
                ...state,
                loading: state.loading+1
            }
        }
        case 'SET_LOADED': {
            return {
                ...state,
                loading: state.loading-1
            }
        }
        default:
            return state
    }
}


export const actions = {
    setLoading: () => ({type: 'SET_LOADING'} as const),
    setLoaded: () => ({type: 'SET_LOADED'} as const),
}


export default loadingReducer
